import gettext from '@sdk/lang/gettext';
import displayDuration from '@sdk/utils/displayDuration';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { DurationRowProps } from '@web/timesheets/CreateTimesheetModal/components/rows/DurationRow/durationRow.types';
import { FieldContainer } from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/modalRow.styles';
import ModalRow from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/ModalRow';
import AutomatedBreaksSummaryForTimesheet from '@web/timesheets/CreateTimesheetModal/components/rows/DurationRow/AutomatedBreaksSummaryForTimesheet';
import { getTotalDurationInMinutes } from '@web/timesheets/CreateTimesheetModal/utils/timeClockUtils';
import { useDurationRow } from '@web/timesheets/CreateTimesheetModal/components/rows/DurationRow/durationRow.hooks';
import DurationIconSvg from '@web/assets/svg/Icons/32/total-gray.svg';

const DurationRow = ({
  shift,
  timeClockEntries,
  entriesDate,
  breakAttestations,
}: DurationRowProps) => {
  const {
    areAutomatedBreaksUsed,
    timeClockEntriesWithDates,
    shouldShowBreakDuration,
    breakDurationInMintues,
    unpaidBreakMinutes,
  } = useDurationRow({
    timeClockEntries,
    entriesDate,
    shift,
  });

  return (
    <ModalRow label={gettext('Duration')} icon={DurationIconSvg}>
      <FieldContainer>
        <div>
          <Text14 themeColor={ThemeColorType.gray}>
            {displayDuration(
              getTotalDurationInMinutes({
                timeClockEntriesWithDates,
                unpaidBreakMinutes,
              })
            )}
          </Text14>
          {shouldShowBreakDuration && Boolean(breakDurationInMintues) && (
            <Text14 themeColor={ThemeColorType.gray}>
              &nbsp;·&nbsp;
              {gettext('%(breakMinutes)s break', {
                breakMinutes: displayDuration(breakDurationInMintues),
              })}
            </Text14>
          )}
          {areAutomatedBreaksUsed && (
            <AutomatedBreaksSummaryForTimesheet
              shift={shift}
              timeClockEntriesWithDates={timeClockEntriesWithDates}
              breakAttestations={breakAttestations}
            />
          )}
        </div>
      </FieldContainer>
    </ModalRow>
  );
};

export default DurationRow;
